import { useContext, Fragment, useMemo } from 'react'

import MapLayersContext from 'tripPlanner/contexts/MapLayers/MapLayersContext'
import Heading from 'LuxKit/Typography/Heading'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import Divider from 'LuxKit/Divider'
import { rem } from 'polished'
import styled from 'styled-components'
import ClickableListItem from 'LuxKit/List/ClickableListItem'
import CheckboxButton from 'LuxKit/Checkbox/CheckboxButton'
import Caption from 'LuxKit/Typography/Caption'
import moment from 'moment'

const ColouredBox = styled(Caption)`
  width: ${rem(48)};
  height: ${rem(24)};
  border-radius: ${props => props.theme.borderRadius.S};
  display: flex;
  align-items: center;
  justify-content: center;
`

const DividerContainer = styled.div`
  padding-block: ${rem(12)};
`

const SubDividerContainer = styled.div`
  padding-inline: ${rem(16)};
`

function MapLayersOptions() {
  const { layerGroups, toggleLayer, toggleGroup } = useContext(MapLayersContext)

  const itineraryGroup = useMemo(() => layerGroups.filter(group => group.id === 'itinerary'), [layerGroups])

  return (
    <>
      {itineraryGroup.map((group, i) => <Fragment key={group.id}>
        {i > 0 && <DividerContainer><Divider kind="primary" /></DividerContainer>}
        <VerticalSpacer gap={8}>
          <Heading variant="heading6" colour="neutral-three">{group.title}</Heading>
          <div>
            {group.layers.length > 1 && !!group.selectAllLabel && <>
              <ClickableListItem
                title={group.selectAllLabel}
                onClick={() => toggleGroup(group.id)}
                endIcon={<CheckboxButton checked={group.selectionStatus === 'all'} indeterminate={group.selectionStatus === 'some'} />}
              />
              <SubDividerContainer><Divider kind="primary" /></SubDividerContainer>
            </>}
            {group.layers.map((layer) => {
              const Icon = layer.icon
              const dayName = moment(layer.title).format('ddd').toUpperCase()
              return <ClickableListItem
                key={`${group.id}-${layer.id}`}
                title={layer.title}
                startIcon={layer.colour ? <ColouredBox variant="medium" weight="bold" colour="neutral-eight" format="uppercase" style={{ backgroundColor: layer.colour }}>{dayName}</ColouredBox> : Icon ? <Icon /> : undefined}
                onClick={() => toggleLayer(group.id, layer.id)}
                endIcon={<CheckboxButton checked={layer.isSelected} />}
              />
            })}
          </div>
        </VerticalSpacer>
      </Fragment>)}
    </>
  )
}

export default MapLayersOptions
